export default __webpack_public_path__ + "static/media/seashell6.3efb8a83.svg";